import SignatureCanvas from "react-signature-canvas";

export default function DrawSignature({canvasRef}) {
    
    return (
        <div className="d-flex justify-content-center">
            <SignatureCanvas
                ref={canvasRef}
                penColor="black"
                canvasProps={{
                    width: 600,
                    height: 230,
                    style: {
                        border: "1px solid #cfcfcf",
                        borderRadius: "4px",
                        display: "block",
                    },
                }}
            />
        </div>
    );
}
